import type { PropsWithChildren } from 'react'
import { Redirect, useLocation } from 'wouter'
import { Button, Result, Spin } from 'antd'
import { ApiError } from '@/services/httpClient'
import { useAuth } from '@/auth/AuthContext'

export function RequireAuth({ children }: PropsWithChildren) {
  const { user, pending, error, retry } = useAuth()
  const [location] = useLocation()
  if (pending) return <div className="route-loading" role="status"><Spin size="large" tip="正在验证管理员身份" /></div>
  if (error && !user) return <Result status={error instanceof ApiError && error.status === 403 ? '403' : 'error'} title={error instanceof ApiError && error.status === 403 ? '没有管理后台访问权限' : '管理员身份暂时无法验证'} subTitle={error.message} extra={<Button onClick={retry}>重新验证</Button>} />
  if (!user) {
    sessionStorage.setItem('learning_admin_return_to', location)
    return <Redirect to="/login" replace />
  }
  return children
}

export function RequirePermission({ permission, children }: PropsWithChildren<{ permission?: string }>) {
  const { can } = useAuth()
  if (!can(permission)) return <Result status="403" title="没有访问权限" subTitle="请联系管理员为当前角色分配所需权限。" />
  return children
}
